<template>
  <div v-if="menuIsOpen" id="wrapper-lu-column-menu" class="mhv-100 h-100" :class="{'menu-collpased': collapsedMode}" v-click-outside="mutationIsOpen" :style="cssVars">
    <router-link to="/" class="logo text-center">
      <b-img :src="logoImgShowed" alt="Logo" fluid></b-img>
    </router-link>
    <ul id="menu-list" role="tablist" class="p-2">
        <b-nav-item
          class="my-3 w-100"
          @click="collapsedModeToggle"
          v-b-tooltip="{ title: 'Menú', placement: 'right', customClass: 'ml-3', disabled: !collapsedMode, trigger: 'hover' }"
        >
          <div class="d-flex align-items-center" :class="{ 'justify-content-center': collapsedMode }">
            <i class="dripicons-menu d-flex"></i>
            <span v-if="!collapsedMode" class="ml-3">{{ $t('Navigation') }}</span>
          </div>
        </b-nav-item>
        <b-nav-item
          :to="el.path"
          class="my-3 w-100"
          exact-active-class="active-item"
          v-for="(el, index) in menuItemsData"
          :key="index"
          v-b-tooltip="{ title: el.name, placement: 'right', customClass: 'ml-3', disabled: !collapsedMode, trigger: 'hover' }"
        >
          <template v-if="el.parent">
            <div
              class="d-flex align-items-center"
              :class="{ 'justify-content-center': collapsedMode }"
              v-b-toggle="el.id"
              @click="onExpandParentMenuPoint"
            >
              <i :class="el.icon" class="d-flex"></i>
              <span v-if="!collapsedMode" class="ml-3">{{ el.name }}</span>
              <i
                v-if="!collapsedMode"
                class="d-flex dripicons ml-2"
                :class="[el.collapsed ? 'dripicons-chevron-right' : 'dripicons dripicons-chevron-down']"
              ></i>
            </div>
            <b-collapse
              tag="ul"
              :id="el.id"
              accordion="accordion-app"
              role="tabpanel"
              class="side-nav-second-level mt-4"
              v-if="!collapsedMode"
              @input="el.collapsed = $event"
            >
              <b-nav-item
                :to="child.path"
                class="my-2 w-100"
                exact-active-class="active-item"
                v-for="(child, index) in el.childs"
                :key="index"
              >
                <div class="d-flex align-items-center">
                  <i v-if="child.icon" :class="child.icon" class="d-flex mr-3"></i>
                  <span >{{ child.name }}</span>
                </div>
              </b-nav-item>
            </b-collapse>
          </template>

          <template v-else>
            <div class="d-flex align-items-center" :class="{ 'justify-content-center': collapsedMode }">
              <i :class="el.icon" class="d-flex"></i>
              <span v-if="!collapsedMode" class="ml-3">{{ el.name }}</span>
            </div>
          </template>

        </b-nav-item>

    </ul>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

import { mapState, mapMutations, mapActions } from 'vuex'
import '@/directives/click-outside.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
library.add(faAngleDoubleLeft, faAngleDoubleRight)

export default {
  data () {
    return {
      collapsedMode: false,
      menuItemsData: []
    }
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('settings', ['logoImg', 'collapsedLogoImg', 'menuBgColor', 'menuFontColor', 'menuActiveFontColor', 'logoAlignItems', 'logoJustifyContent', 'logoWidth', 'logoPadding']),
    ...mapState('menu', ['menuIsOpen']),
    collapseIcon () {
      return this.collapsedMode ? 'angle-double-right' : 'angle-double-left'
    },
    logoImgShowed () {
      return this.collapsedMode ? this.collapsedLogoImg : this.logoImg
    },
    cssVars () {
      return {
        '--menu-bg-color': this.menuBgColor,
        '--menu-font-color': this.menuFontColor,
        '--active-menu-font-color': this.menuActiveFontColor,
        '--logo-align-items': this.logoAlignItems,
        '--logo-justify-content': this.logoJustifyContent,
        '--logo-width': this.logoWidth,
        '--logo-padding': this.logoPadding
      }
    }
  },
  methods: {
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapActions('menu', ['menuOnResize']),
    collapsedModeToggle () {
      // Oculto todos los tooltips
      this.$root.$emit('bv::hide::tooltip')
      this.collapsedMode = !this.collapsedMode
      this.$emit('expanded', !this.collapsedMode)
    },
    onExpandParentMenuPoint () {
      // Oculto todos los tooltips
      this.$root.$emit('bv::hide::tooltip')
      this.collapsedMode = false
      this.$emit('expanded', true)
    },
    horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside () {
      this.menuItemsData = []
      this.menuItemsData = this.menuItems.map(item => {
        return {
          collapsed: false,
          ...item
        }
      })
    },
    isVisible (menuPath) {
      return menuPath.some(el => '/' + el?.path.split('/')[1] === this.$route.matched[1]?.path)
    }
  },
  directives: {
    ClickOutside
  },
  watch: {
    '$route.path' () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    },
    menuItems () {
      this.horribleWorkAroundToFixInASafeWayALateFoundProblemShowsChildsLinksWhenNavigatedMenuFromOutside()
    }
  },
  mounted () {
    this.menuOnResize()
  }

}
</script>

<style lang="sass" scoped>
#wrapper-lu-column-menu
  background: var(--menu-bg-color)
  font-size: .95rem
  @media(max-width: $xl)
    position: fixed
    z-index: 10
  a,
  .side-nav-item
    color: var(--menu-font-color)
  button
    color: var(--menu-font-color)
    font-size: 15px
    &:hover
      color: white
      text-decoration: none
  .logo
    display: flex
    align-items: var(--logo-align-items)
    justify-content: var(--logo-justify-content)
    padding: var(--logo-padding)
  .img-logo
    width: var(--logo-width)
    height: auto
  .active-item
    border-radius: 8px
    background-color: rgba(41, 41, 41, 0.6)
  &.menu-collpased
    .logo
      img
        max-width: 70px
</style>
